import React from "react";
import TemplateFooterSection from "../pages/Dashboard/Training/Endorsement/templates/TemplateFooterSection";
function TemplateLayout({
  children,
  templateName,
}: {
  children: React.ReactNode;
  templateName?: string;
}) {
  return (
    <div style={{ background: "#F8FAFB", padding: "24px", margin: ".8rem 0" }} className="layout_wrapper">
      <div className="row">
        <div className="col-12 my-2">
          <input
            type="text"
            className="form-control"
            value={templateName}
            readOnly
          />
        </div>
        {children}
        <TemplateFooterSection />
      </div>
    </div>
  );
}
export default TemplateLayout;
